import React, { Component } from 'react';

class LiteralForm extends Component {

    state= {
        text: "",
        domain: "",
        value: "",
        showLabel: true,
        hidden: "",
        width:"",
        offset:"",
        rowIndex: -1
    }

    counter = 0;
    getCounter = ()=>{
        return this.counter++
    }

    constructor(props){
        super(props)

        this.state.text = props.data.text;
        var literal_id = this.state.text;
        if(props.data.domain !== undefined && props.data.domain !== ""){
            literal_id = props.data.domain;
        } 
        var word = '';
        if(Array.isArray(props.data.values)){
            var iterator = props.data.values.values();            
            for (let letter of iterator) {
                word += letter;
            }
        }
        this.state.value = word;
        this.state.showLabel= props.showLabel;
        this.state.hidden = props.data.hidden;
        this.state.width= props.data.width;
        this.state.offset= props.data.offset;
        this.state.rowIndex = props.rowIndex;

        props.addToResult(literal_id, this.state.value, this.state.rowIndex);
    }
    getWidthClass(width) {
        switch (width) {
            case 0:
                return "";
            case 1:
                return "col-1";
            case 2:
                return "col-2";
            case 3:
                return "col-3";
            case 4:
                return "col-4";
            case 5:
                return "col-5";
            case 6:
                return "col-6";
            case 7:
                return "col-7";
            case 8:
                return "col-8";
            case 9:
                return "col-9";
            case 10:
                return "col-10";
            case 11:
                return "col-11";
            case 12:
                return "col-12";
            default:
                //return <Input addToResult={this.addToResult} formJson={item} />
                return "";
        }                
    }

    getOffsetClass(offset) {
        switch (offset) {
            case 0:
                return "";
            case 1:
                return "offset-1";
            case 2:
                return "offset-2";
            case 3:
                return "offset-3";
            case 4:
                return "offset-4";
            case 5:
                return "offset-5";
            case 6:
                return "offset-6";
            case 7:
                return "offset-7";
            case 8:
                return "offset-8";
            case 9:
                return "offset-9";
            case 10:
                return "offset-10";
            case 11:
                return "offset-11";
            default:
                //return <Input addToResult={this.addToResult} formJson={item} />
                return "";
        }                
    }
    
    getClassElement(width, offset) {
        return this.getWidthClass(width) +" " + this.getOffsetClass(offset);
    }

    render() {
        let label;
        if (this.state.showLabel){
            label = <label htmlFor={this.state.id}>{this.state.text}</label>
        }  
        const createMarkup = htmlString => ({ __html: htmlString });
        return (
            <div className={this.getClassElement(this.state.width, this.state.offset)} hidden={this.state.hidden ||''}>
                {label}
                <div dangerouslySetInnerHTML={createMarkup(this.state.value)}></div>
            </div>
        );
    }
}

export default LiteralForm;